import {on, findAll, addClass, findIn, removeClass, closest} from '@elements/dom-utils';

export function init() {
    const anchorLinks = findAll('.js-anchor-nav__link');
    const isMobile = () => matchMedia('(max-width: 767px)').matches;

    if (!anchorLinks || anchorLinks.length === 0) {
        return;
    }
    else {
        activateAnchorOnScroll();
    }

    anchorLinks.forEach((anchorLink) => {
        on('click', (event) => {
            const clickedLink = event.target;
            const anchorLink = clickedLink.closest('.js-anchor-nav__link');

            if (!anchorLink) {
                return;
            }

            anchorLinks.forEach((link) => {
                removeClass('active', link);
            });

            addClass('active', anchorLink);

        }, anchorLink);
    });

    function activateAnchorOnScroll() {
        const anchorLinks = findAll('.anchor-nav__link');
        const linkMap = new Map();

        anchorLinks.forEach((link) => {
            const href = link.getAttribute('href');
            if (href && href.startsWith('#')) {
                const target = document.querySelector(href);
                if (target) {
                    linkMap.set(target, link);
                }
            }
        });

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    anchorLinks.forEach((link) => removeClass('active', link));
                    const activeLink = linkMap.get(entry.target);
                    if (activeLink) {
                        addClass('active', activeLink);
                    }

                    let activeLinkWrapper = closest('.js-anchor-nav__item', activeLink);
                    let linkList = closest('.js-anchor-nav__list', activeLink);
                    center(linkList, activeLinkWrapper);

                }
            });
        }, { threshold: 0.25 });

        linkMap.forEach((_, target) => observer.observe(target));
    }
    function center(scrollParent, activeLi) {
        if (activeLi) {
            let childPos = activeLi.offsetLeft,
                offset = childPos - scrollParent.offsetWidth / 2 + activeLi.getBoundingClientRect().width / 2 - scrollParent.offsetLeft;
            scrollParent.scroll({
                left: offset,
                behavior: "smooth"
            });
        }
    }

}